import {
  Box,
  Button,
  Divider,
  Drawer,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { getPokemons, getPokemon } from "./Pokemon";
import PokemonCard from "./PokemonCard";
import "../index.css";
import {
  ArrowCircleDown,
  ArrowCircleUp,
  FilterList,
  Search,
  SettingsInputAntennaTwoTone,
} from "@mui/icons-material";
function Allpokemon() {
  const [filterType, setFilterType] = useState("0-9");
  const [open, setOpen] = useState({
    top: false,
  });
  const [pokemons, setPokemons] = useState([]);
  const [x, setX] = useState(64);
  getPokemons(x).then((data) => {
    setPokemons(data);
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen({ ...open, [anchor]: open });
  };

  const handleChange = (event) => {
    setFilterType(event.target.value);
    console.log(filterType);
    console.log(x);
    if (filterType === "9-0") {
      setX("911");
    } else if (filterType === "0-9") {
      setX("64");
    }
  };

  const list = (anchor) => (
    <div>
      <Box
        sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
      >
        <List>
          {["Water", "Fire", "Water"].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
      </Box>
    </div>
  );

  return (
    <div
      style={{
        marginTop: "3%",
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        justifyContent: "center",
        marginBottom: "2%",
        textAlign: "center",
      }}
    >
      {" "}
      <h1 className="title">Pokemon Dictionary(Pokedex)</h1>
      <div className="row flex jcenter">
        <div>
          {["top"].map((anchor) => (
            <div>
              <Button
                style={{ marginBottom: "2%" }}
                onClick={toggleDrawer(anchor, true)}
                variant="outlined"
              >
                <FilterList />
                Show Advanced Search
              </Button>
              <React.Fragment key={anchor}>
                <Drawer
                  anchor={anchor}
                  open={open[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                >
                  {list(anchor)}
                </Drawer>
              </React.Fragment>
            </div>
          ))}
        </div>
        <Box sx={{ minWidth: 120 }} id="sort">
          <FormControl fullWidth>
            {" "}
            <InputLabel id="sort label">Sort by..</InputLabel>
            <Select
              labelId="simple-filter"
              id="simple-search"
              value={filterType}
              label="Sort by..."
              onChange={handleChange}
            >
              <MenuItem value={0 - 9}>0-9</MenuItem>
              <MenuItem value={9 - 0}>9-0</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "2%",
          textAlign: "center",
        }}
      >
        {Object.entries(pokemons)[3] &&
          Object.entries(pokemons)[3][1].map((pokemon, index) => {
            return (
              <div className="dex">
                <PokemonCard
                  style={{
                    maxWidth: "12.5%",
                    minWidth: "12.5%",
                    maxHeight: "12.5%",
                    minHeight: "12.5%",
                  }}
                  key={index}
                  className="pokemon"
                  {...pokemon}
                  id={index + 1}
                />
              </div>
            );
          })}
      </div>
      <Button
        variant="contained"
        style={{
          textAlign: "center",
          marginBottom: "10%",
          maxWidth: "10%",
          marginLeft: "45%",
          marginRight: "45%",
        }}
        onClick={() => {
          if (filterType === "0-9") {
            setX(x + 128);
            getPokemons(x).then((data) => {
              setPokemons(data);
            });
          } else if (filterType === "9-0") {
            setX(x - 128);
            getPokemon(x).then((data) => {
              setPokemons(data);
            });
          }
        }}
      >
        Load More
      </Button>
    </div>
  );
}

export default Allpokemon;
